// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3Ldk-","title":"card_title__3yeY5","inActive":"card_inActive__1DZkz"};